import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fields_list: [],
  entity_list: [],
  selected_entity: null,
  project_details: [],
  removed_field: '',
  template_name: '',
};

const entityLayoutConfigSlice = createSlice({
  name: 'entityLayoutConfig',
  initialState: initialState,
  reducers: {
    setEntityLayoutConfig(state, { payload }) {
      state.fields_list = Object.prototype.hasOwnProperty.call(
        payload,
        'fields_list'
      )
        ? payload.fields_list
        : state.fields_list;
      state.entity_list = Object.prototype.hasOwnProperty.call(
        payload,
        'entity_list'
      )
        ? payload.entity_list
        : state.entity_list;

      state.selected_entity = Object.prototype.hasOwnProperty.call(
        payload,
        'selected_entity'
      )
        ? payload.selected_entity
        : state.selected_entity;

      state.project_details = Object.prototype.hasOwnProperty.call(
        payload,
        'project_details'
      )
        ? payload.project_details
        : state.project_details;

      state.removed_field = Object.prototype.hasOwnProperty.call(
        payload,
        'removed_field'
      )
        ? payload.removed_field
        : state.removed_field;
      state.template_name = Object.prototype.hasOwnProperty.call(
        payload,
        'template_name'
      )
        ? payload.template_name
        : state.template_name;
    },
  },
});

export const { setEntityLayoutConfig } = entityLayoutConfigSlice.actions;

export const entityLayoutConfigReducer = entityLayoutConfigSlice.reducer;
